import { axiosInstance } from "../axios";

export const loginLeste = async ({ username, password }) => {
    return axiosInstance
        .post(`/leste/login/`, {
            username,
            password
        })
};